export default "__VITE_ASSET__DRcjw_9w__"